import type { LayoutArea } from '@hibro/shared';
import { createContext, type ReactNode } from 'react';

/**
 * Carries the current area-content renderer into dockview panels.
 * dockview-react mounts panels through React Portals, which preserve the
 * React Context chain, so updates to this value propagate to all panels
 * without rebuilding the grid structure (架构方案 §5.7).
 *
 * dockview owns panel instantiation and only forwards serializable `params`, so
 * the per-render `areaContent` closure (over `slots` / `registry` / …) cannot go
 * through params — this Context is the bridge. See `layout.tsx` (provider) and
 * `AreaPanel` in `panels.tsx` (consumer).
 */
export const AreaContentContext = createContext<
  (area: LayoutArea) => ReactNode
>(() => null);
